import { Phone } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ButtonWhatsapp from '@/domains/traffic-monitoring/components/ButtonWhatsapp/ButtonWhatsapp';

interface ContactItem {
  name: string;
  phone: string;
}

interface ModalSupportProps {
  isOpen?: boolean;
  onClose?: () => void;
  onCall?: (phone: string) => void;
  contacts: ContactItem[];
}

const ModalSupport = ({ isOpen, onCall, onClose, contacts }: ModalSupportProps) => {
  const { t } = useTranslation();

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="w-full max-w-md rounded-[16px] bg-white p-5">
        {/* Header */}
        <div className="mb-4 flex items-center justify-between">
          <span className="title1bold text-black">{t('psc>report>support contact')}</span>

          <button
            type="button"
            onClick={onClose}
            className="text-xl text-text-grey"
            aria-label="Close"
          >
            ×
          </button>
        </div>

        <div className="flex max-h-[60vh] flex-col gap-3 overflow-y-auto">
          {contacts.map((contact) => (
            <div
              key={`${contact.name}-${contact.phone}`}
              className="flex items-center justify-between gap-3 rounded-[12px] border p-3"
            >
              <div className="flex min-w-0 flex-col">
                <span className="title1bold truncate text-black">{contact.name}</span>
                <div className="flex flex-row items-cente gap-3">
                  <Phone size={20} color="grey" />
                  <span className="tilte1 text-text-grey">{contact.phone}</span>
                </div>
              </div>

              <ButtonWhatsapp
                styleButton=""
                label={t('psc>report>call')}
                onclick={() => onCall?.(contact.phone)}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ModalSupport;
